import {HttpClient} from "../httpClient/HttpClient";
import {LanguageHelper} from "../../util/LanguageHelper";


export class ResidenceService {

    constructor() {
        this.httpClient = new HttpClient();
    }


    getResidence(page, size,title) {
        return this.httpClient.get(
            `residences`,
            {
                page,
                size,
                title,
                "language-code": LanguageHelper.getLanguageCode(),
            }
        )
    }

    getResidenceDetail(residenceId, languageId) {
        return this.httpClient.get(
            `residences/${residenceId}`,
            {
                "language-code": languageId
            })
    }

    updateInfo(id, languageCode, title, menCapacity, womenCapacity, address) {
        return this.httpClient.put(
            `languages/${languageCode}/residences/${id}`,
            {
                menCapacity,
                womenCapacity,
                "metaData": {
                    title,
                    address
                }
            }
        )
    }

    updateResidenceManager(residenceId, managerId) {
        return this.httpClient.put(
            `residences/${residenceId}/clerks`,
            {
                clerkId: managerId,
            }
        )
    }


    getResidenceManager(residenceId, languageId) {
        return this.httpClient.get(
            `residences/${residenceId}/clerks`,
            {
                "language-code": LanguageHelper.getLanguageCode(),
            }
        )
    }

    getResidenceGeoInfo(id) {
        return this.httpClient.get(
            `residences/${id}/geographical`,
        )
    }

    updateResidenceGeoInfo(residenceId, latitude, longitude) {
        return this.httpClient.put(
            `residences/${residenceId}/geographical`,
            {
                latitude, longitude
            }
        )
    }

    createNewResidence(title, menCapacity, womenCapacity) {
        return  this.httpClient.post(
            `languages/${LanguageHelper.getLanguageCode()}/residences`,
            {
                metaData: {
                    title
                },
                menCapacity,
                womenCapacity
            }
        )
    }
    getResidenceList(page, size,title) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `residences`,
                {
                    page, size,
                    title,
                    "language-code": LanguageHelper.getLanguageCode(),
                }
            ).then(resolve).catch(reject)
        })
    }
}